import { RefObject, useCallback, useEffect } from 'react';
import { sentryClient } from '../../services/sentryClient';

export const useVideoPlay = ({
  videoElementRef,
  isPlaying,
}: {
  videoElementRef: RefObject<HTMLVideoElement>;
  isPlaying: boolean;
}) => {
  let playPromise = Promise.resolve();

  const stopPlaying = useCallback(() => {
    const { current: videoElement } = videoElementRef;
    if (!videoElement) {
      return;
    }

    void playPromise.then(() => {
      videoElement.pause();
      videoElement.currentTime = 0;
    });
  }, [videoElementRef]);

  useEffect(() => {
    const { current: videoElement } = videoElementRef;

    if (!videoElement) {
      return;
    }

    if (isPlaying) {
      playPromise = videoElement.play() || Promise.resolve();

      playPromise.catch((error) => {
        sentryClient.captureException(error);
        stopPlaying();
      });
      return;
    }

    stopPlaying();
  }, [videoElementRef, isPlaying, stopPlaying]);
};
